import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AppProvider, useApp } from "@/context/AppContext";
import Landing from "@/pages/Landing";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import Grants from "@/pages/Grants";
import Claims from "@/pages/Claims";
import Applications from "@/pages/Applications";
import Detail from "@/pages/Detail";
import AppShell from "@/components/layout/AppShell";
import Auth from "@/pages/Auth";
import ProfileVault from "@/pages/ProfileVault";
import Notifications from "@/pages/Notifications";
import Premium from "@/pages/Premium";
import LiveGrants from "@/pages/LiveGrants";
import Admin from "@/pages/Admin";
import Affidavits from "@/pages/Affidavits";
import Demo, { DemoProgram } from "@/pages/Demo";
import Won from "@/pages/Won";
import Capabilities from "@/pages/Capabilities";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";

function RequireAuth({ children }) {
    const { isAuthed, booting } = useApp();
    const loc = useLocation();
    if (booting) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-background">
                <div className="animate-pulse text-muted-foreground text-sm">Loading…</div>
            </div>
        );
    }
    if (!isAuthed) return <Navigate to="/auth" replace state={{ from: loc.pathname }} />;
    return children;
}

function App() {
    return (
        <div className="App">
            <AppProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<Landing />} />
                        <Route path="/auth" element={<Auth />} />
                        <Route path="/demo" element={<Demo />} />
                        <Route path="/demo/grant/:id" element={<DemoProgram />} />
                        <Route path="/won/:code" element={<Won />} />
                        <Route path="/capabilities" element={<Capabilities />} />
                        <Route path="/forgot-password" element={<ForgotPassword />} />
                        <Route path="/reset-password" element={<ResetPassword />} />
                        <Route path="/onboarding" element={<RequireAuth><Onboarding /></RequireAuth>} />
                        <Route path="/app" element={<RequireAuth><AppShell /></RequireAuth>}>
                            <Route index element={<Navigate to="/app/dashboard" replace />} />
                            <Route path="dashboard" element={<Dashboard />} />
                            <Route path="grants" element={<Grants />} />
                            <Route path="live" element={<LiveGrants />} />
                            <Route path="claims" element={<Claims />} />
                            <Route path="applications" element={<Applications />} />
                            <Route path="vault" element={<ProfileVault />} />
                            <Route path="affidavits" element={<Affidavits />} />
                            <Route path="inbox" element={<Notifications />} />
                            <Route path="premium" element={<Premium />} />
                            <Route path="admin" element={<Admin />} />
                            <Route path="detail/:type/:id" element={<Detail />} />
                        </Route>
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </BrowserRouter>
                <Toaster position="top-right" richColors closeButton />
            </AppProvider>
        </div>
    );
}

export default App;
